export const testAttributes = {
    SINGLE_CTA_BUTTON: 'cta_banner_button_',
    SINGLE_CTA_BUTTON_ICON: 'cta_button_icon_',
    VARIANT_OUTLINED: 'variant-outlined',
};

export const defaultAttributes = {
    color: 'green',
    filled: 'filled',
    outlined: 'outlined',
};
